import c from 'classnames';
import { InputRule, wrappingInputRule } from 'prosemirror-inputrules';
import { ParseSpec } from 'prosemirror-markdown';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions } from '@lyearn/lygo-core';

import { BLOCKQUOTE_REGEX, NODE_NAME } from './consts';
import plugins from './plugins';
import { quoteBlockStyles, quoteTextStyles } from './styles';

export default class Blockquote extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        id: { default: null },
      },
      content: 'inline*',
      group: 'block',
      defining: true,
      parseDOM: [{ tag: 'blockquote' }],
      toDOM(node) {
        return [
          'blockquote',
          { class: c('my-32', quoteBlockStyles), id: node.attrs.id },
          [
            'p',
            {
              class: c('ps-16 border-s-2 border-solid text-text-primary', quoteTextStyles),
            },
            0,
          ],
        ];
      },
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      block: NODE_NAME,
    };
  }

  inputRules({ schema }: EditorOptions) {
    return [
      new InputRule(BLOCKQUOTE_REGEX, (state, match, start, end) => {
        const [okay] = match;
        const { tr } = state;

        if (okay) {
          tr.replaceWith(start - 1, end, schema.nodes.blockquote.create());
        }

        return tr;
      }),
    ];
  }

  plugins = plugins;
}
